import { useEffect, useState } from "react";

export const useWasScrolled = () => {
    const [wasScrolled, setWasScrolled] = useState(false);
    useEffect(() => {
        if (!window) return;
        const scrollHandler = (event) => {
            setWasScrolled(true);
            window.removeEventListener("scroll", scrollHandler);
        };
        window.addEventListener("scroll", scrollHandler);
        return () => {
            window.removeEventListener("scroll", scrollHandler);
        };
    }, []);
    return wasScrolled;
};
